export const ValidationLimitTypes = {
  MIN_STORAGE_ITEM_NAME_LENGTH: 1,
  MAX_STORAGE_ITEM_NAME_LENGTH: 255
};
